/* knowledge-card-loading.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./knowledge-card-loading.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useEffect } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import { cx } from '@atlaskit/css';
import Image from '@atlaskit/image';
import { fg } from '@atlaskit/platform-feature-flags';
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { AnimatedWrapper } from '@atlassian/ai-common';
import { useAIAnswerContext } from '../ai-answer-dialog/ai-answer-context';
import GeneratingAnimation from '../ai-answer-dialog/ai-answer-loading/generating-animation';
import { RovoGeneratingAnimation } from '../ai-answer-dialog/ai-answer-loading/rovo-generating-animation';
import { onKnowledgeCardLoadingDialogShown } from '../ai-answer-dialog/analytics';
import { useAnalytics } from '../common/controller/analytics/use-analytics';
import { QueryIntent } from '../constants';
import RovoIcon from '../v2/common/ui/assets/Rovo.svg';
var styles = {
  container: "_ca0qpxbi _19bvpxbi _4t3ibn52",
  containerNewSAINLoading: "_u5f3pxbi _19bvpxbi _ca0qpxbi _n3tdpxbi _4t3ibn52",
  inline: "_19bvu2gc _u5f3u2gc _4t3i1ylp",
  agentCardHeightOverride: "_4t3igrxc"
};
var messages = defineMessages({
  knowledge_card_loading: {
    id: 'search_ai.knowledge_card_loading',
    defaultMessage: 'Searching across your connected apps',
    description: 'Text for knowledge card loading state'
  },
  knowledge_card_rovo_is_thinking: {
    id: 'search_ai.knowledge_card_rovo_is_thinking',
    defaultMessage: 'Rovo is thinking',
    description: 'Text for the knowledge card "Rovo is thinking" loading state'
  }
});
export function KnowledgeCardLoading(_ref) {
  var queryIntent = _ref.queryIntent;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var showNewSAINLoading = fg('kd_sain_rovo_loading');
  useEffect(function () {
    fireAnalyticsEvent(onKnowledgeCardLoadingDialogShown(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (showNewSAINLoading) {
    return /*#__PURE__*/React.createElement(AnimatedWrapper, null, /*#__PURE__*/React.createElement(Stack, {
      xcss: cx(styles.containerNewSAINLoading, queryIntent === QueryIntent.AGENT && styles.agentCardHeightOverride),
      space: "space.200"
    }, /*#__PURE__*/React.createElement(Inline, {
      space: 'space.100',
      xcss: styles.inline,
      alignBlock: "center"
    }, /*#__PURE__*/React.createElement(Image, {
      src: RovoIcon,
      alt: ""
    }), /*#__PURE__*/React.createElement(Inline, null, /*#__PURE__*/React.createElement(Text, {
      color: 'color.text.subtle'
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.knowledge_card_rovo_is_thinking)), /*#__PURE__*/React.createElement(RovoGeneratingAnimation, null))), /*#__PURE__*/React.createElement(Skeleton, {
      width: "100%",
      height: "16px",
      color: "var(--ds-skeleton-subtle, #17171708)"
    }), /*#__PURE__*/React.createElement(Skeleton, {
      width: "100%",
      height: "16px",
      color: "var(--ds-skeleton-subtle, #17171708)"
    }), /*#__PURE__*/React.createElement(Skeleton, {
      width: "90%",
      height: "16px",
      color: "var(--ds-skeleton-subtle, #17171708)"
    })));
  }
  return /*#__PURE__*/React.createElement(AnimatedWrapper, null, /*#__PURE__*/React.createElement(Inline, {
    xcss: cx(styles.container, queryIntent === QueryIntent.AGENT && styles.agentCardHeightOverride),
    space: "space.050"
  }, /*#__PURE__*/React.createElement(GeneratingAnimation, null), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.knowledge_card_loading))));
}